import { useCallback } from 'react';
export function useVariablePickerKeyboard(_ref) {
  let {
    selectableItems,
    highlightedIndex,
    setHighlightedIndex,
    onSelect,
    onClose
  } = _ref;
  return useCallback(event => {
    switch (event.key) {
      case 'ArrowDown':
        {
          event.preventDefault();
          setHighlightedIndex(prev => selectableItems.length > 0 ? (prev + 1) % selectableItems.length : prev);
          break;
        }
      case 'ArrowUp':
        {
          event.preventDefault();
          setHighlightedIndex(prev => selectableItems.length > 0 ? (prev - 1 + selectableItems.length) % selectableItems.length : prev);
          break;
        }
      case 'Enter':
        {
          event.preventDefault();
          if (selectableItems.length > 0 && highlightedIndex < selectableItems.length) {
            onSelect(selectableItems[highlightedIndex].label);
          }
          break;
        }
      case 'Escape':
        {
          event.preventDefault();
          event.stopPropagation();
          onClose();
          break;
        }
    }
  }, [selectableItems, highlightedIndex, setHighlightedIndex, onSelect, onClose]);
}